import { createAppSelector, selectCurrentCourseId } from "./base";

import { RecordingSessionState } from "components/server-types";

export const selectRecordingSessions = createAppSelector(
  [(state) => state.recording_sessions],
  (recording_sessions) => Object.values(recording_sessions),
);

export const selectRecordingSessionByClassSessionId = createAppSelector(
  [selectRecordingSessions, (state, classSessionId: string) => classSessionId],
  (recordingSessions, classSessionId) =>
    recordingSessions.find((rs) => rs.class_session_id === classSessionId),
);

export const selectRecordingSessionsForCurrentCourse = createAppSelector(
  [selectRecordingSessions, selectCurrentCourseId],
  (recordingSessions, currentCourseId) =>
    recordingSessions.filter((rs) => rs.course_id === currentCourseId),
);

export const selectActiveRecordingSessionForCurrentCourse = createAppSelector(
  [selectRecordingSessionsForCurrentCourse],
  (recordingSessions) =>
    recordingSessions.find((rs) =>
      [
        RecordingSessionState.PREPARING,
        RecordingSessionState.STARTING,
        RecordingSessionState.STARTED,
      ].includes(rs.state),
    ),
);
